var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticStyle:{"margin":"50px","width":"500px"}},[_c('v-card-title',{staticClass:"text-h5"},[_vm._v(" In Bearbeitung ")]),_c('v-card-subtitle'),_c('v-card-text',{staticStyle:{"font-size":"large","text-align":"left"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }